import View from "./View";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitType from "split-type";

class contactsView extends View {
  _contactSection = document.querySelector(".contact  ");
  _contactTitle = document.querySelector(".contact__title");
  _contactIntro = document.querySelector(".contact__intro");
  _contactPanel = document.querySelector(".contact__panel");
  _cityMap = document.querySelector(".contact__city-map");
  _scroller = gsap.registerPlugin(ScrollTrigger);

  addHandlerScrollAnimation() {
    //Set everything to the right
    gsap.set(this._contactTitle, {
      x: window.innerWidth - this._contactTitle.offsetWidth,
    });

    //Set everything to the right
    gsap.set(this._contactPanel, {
      x: window.innerWidth - this._contactPanel.offsetWidth,
    });

    gsap.set(this._cityMap, {
      y: this._cityMap.offsetHeight,
    });

    //Contact title animation
    gsap.to(this._contactTitle, {
      x: 0,
      scrollTrigger: {
        trigger: this._contactSection,
        start: "top bottom",
        end: "top top",
        toggleActions: "restart none none reverse",
        scrub: true,
      },
    });

    gsap.to(this._contactPanel, {
      x: 0,
      scrollTrigger: {
        trigger: this._contactSection,
        start: "top bottom",
        end: "top top",
        toggleActions: "restart none none reverse",
        scrub: true,
      },
    });

    const text = new SplitType(this._contactIntro);

    //Quote descripiton animation
    gsap.from(text.words, {
      opacity: 0,
      y: 30,
      stagger: { amount: 2 },
      scrollTrigger: {
        trigger: this._contactIntro,
        start: "50% bottom",
        end: "top 20%",
        scrub: true,
      },
    });

    gsap.to(this._cityMap, {
      y: 0,
      scrollTrigger: {
        trigger: this._contactSection,
        start: "top bottom",
        end: "top top",

        toggleActions: "restart none none reverse",
        scrub: true,
      },
    });
  }
}

export default new contactsView();
